import React, { useState,useEffect } from 'react';
import style from '../../modules/city/city.module.css'
    const citiesData = {
        'Москва и Московская область' : [ 
          'Москва',
          'Абрамцево',
          'Алабино',
           'Апрелевка',
           'Архангельское',
           'Ашитково',
           'Байконур',
           'Бакшеево',
           'Балашиха',
           'Барыбино',
           'Белозёрский',
           'Белоомут',
           'Белые Столбы',
           'Бородино (Московская область)',
           'Бронницы',
           'Быково (Московская область)',
           'Валуево',
           'Вербилки',
           'Верея',
           'Видное',
           'Внуково',
           'Вождь Пролетариата',
           'Волоколамск',
           'Вороново',
           'Воскресенск',
           'Восточный',
           'Востряково',
           'Высоковск',
           'Голицыно (Московская область)',
           'Деденево',
           'Дедовск',
           'Дзержинский',
           'Дмитров',
           'Долгопрудный',
           'Домодедово',
           'Дорохово',
           'Дрезна',
           'Дубки',
           'Дубна',
           'Егорьевск',
           'Железнодорожный (Московск.)',
           'Жилево',
           'Жуковка',
           'Жуковский',
           'Загорск',
           'Загорянский',
           'Запрудная',
           'Зарайск',
           'Звенигород',
           'Зеленоград',
           'Ивантеевка (Московская область)',
           'Икша',
           'Ильинский (Московская область)',
           'Истра',
           'Калининец',
           'Кашира',
           'Керва',
           'Климовск',
           'Клин',
           'Клязьма',
           'Кожино',
           'Кокошкино',
           'Коломна',
           'Колюбакино',
           'Королев',
           'Косино',
           'Котельники',
           'Красково',
           'Красноармейск (Московская область)',
           'Красногорск',
           'Краснозаводск',
           'Краснознаменск (Московская область)',
           'Красный Ткач',
           'Крюково',
           'Кубинка',
           'Купавна',
          'Куровское',
          'Лесной Городок',
          'Ликино-Дулево',
          'Лобня',
          'Лопатинский',
          'Лосино-Петровский',
           'Лотошино',
           'Лукино',
           'Луховицы',
           'Лыткарино',
           'Львовский',
           'Люберцы',
           'Малаховка',
           'Михайловское',
           'Михнево',
           'Можайск',
           'Монино',
           'Московский',
           'Муханово',
           'Мытищи',
           'Нарофоминск',
           'Нахабино',
           'Некрасовка',
           'Немчиновка',
           'Новобратцевский',
           'Новоподрезково',
           'Ногинск',
           'Обухово',
           'Одинцово',
           'Ожерелье',
           'Озеры',
           'Октябрьский (Московская область)',
           'Опалиха',
           'Орехово-Зуево',
           'Павловский Посад',
           'Первомайский (Московская область)',
           'Пески (Московская область)',
           'Пироговский',
           'Подольск',
           'Полушкино',
           'Правдинский',
           'Привокзальный',
           'Пролетарский',
           'Протвино (Московская область)',
           'Пушкино',
           'Пущино',
           'Раменское',
           'Реутов',
           'Решетниково',
           'Родники (Московская область)',
           'Рошаль',
           'Рублево',
           'Руза',
           'Салтыковка',
           'Северный',
           'Сергиев Посад',
           'Серебряные Пруды',
           'Серпухов',
           'Солнечногорск',
           'Солнцево',
           'Софрино',
           'Старая Купавна',
           'Старбеево',
           'Ступино',
           'Сходня',
           'Талдом',
           'Текстильщик',
           'Темпы',
           'Томилино',
           'Троицк',
           'Туголесский Бор',
           'Тучково',
           'Уваровка',
           'Удельная',
           'Успенское',
           'Фирсановка',
           'Фрязино',
           'Фряново',
           'Химки',
           'Хотьково',
           'Черкизово',
           'Черноголовка',
           'Черусти',
           'Чехов',
           'Шарапово',
           'Шатура',
           'Шатурторф',
           'Шаховская',
           'Шереметьевский',
           'Щелково',
           'Щербинка',
           'Электрогорск',
           'Электросталь',
           'Электроугли',
           'Юбилейный (Московская область)',
           'Яхрома',
        ],
        'Санкт-Петербург и область' :  [
           'Санкт-Петербург',
           'Александровская',
           'Бокситогорск',
           'Большая Ижора',
           'Будогощь',
           'Вознесенье',
           'Волосово',
           'Волхов',
           'Всеволожск',
           'Выборг',
           'Вырица',
           'Высоцк',
           'Гатчина',
           'Дружная Горка',
           'Дубровка',
           'Ефимовский',
           'Зеленогорск (Ленинградская область)',
           'Ивангород',
           'Каменногорск',
           'Кикерино',
           'Кингисепп',
           'Кириши',
           'Кировск',
           'Кобринское',
           'Колпино',
           'Коммунар',
           'Коммунар',
           'Кронштадт',
           'Лисий Нос',
           'Лодейное Поле',
           'Ломоносов',
           'Луга',
           'Павловск (Ленинградская область)',
           'Парголово',
           'Петродворец',
           'Пикалёво',
           'Подпорожье',
           'Приозерск',
           'Пушкин',
           'Светогорск',
           'Сертолово',
           'Сестрорецк',
           'Сланцы',
           'Сосновый Бор',
           'Тихвин',
           'Тосно',
           'Шлиссельбург',
        ],
        'Адыгея' : [ 
           'Адыгейск',
           'Майкоп (Адыгея)',
        ],
        'Алтайский край' : [ 
           'Акташ',
           'Акутиха',
           'Алейск',
           'Алтайский',
           'Баево',
           'Барнаул',
           'Белово (Алтайский край)',
           'Белокуриха',
           'Белоярск',
           'Бийск',
           'Благовещенск',
           'Боровлянка',
           'Бурла',
           'Бурсоль',
           'Быстрый Исток',
           'Волчиха',
           'Горно-Алтайск',
           'Горняк',
           'Ельцовка',
           'Залесово',
           'Заринск',
           'Заток',
           'Змеиногорск',
           'Камень-на-Оби',
           'Ключи (Алтайский край)',
           'Кош-Агач',
           'Красногорское (Алтайский край)',
           'Краснощеково',
           'Кулунда',
           'Кытманово',
           'Мамонтово',
           'Новичиха',
           'Новоалтайск',
           'Онгудай',
           'Павловск (Алтайский край)',
           'Петропавловское',
           'Поспелиха',
           'Ребриха',
           'Родино',
           'Рубцовск',
           'Славгород',
           'Смоленское',
           'Солонешное',
           'Солтон',
           'Староаллейское',
           'Табуны',
           'Тальменка',
           'Тогул',
           'Топчиха',
           'Троицкое (Алтайский край)',
           'Турочак',
           'Тюменцево',
           'Угловское',
           'Усть-Калманка',
           'Усть-Кан',
           'Усть-Кокса',
           'Усть-Улаган',
           'Усть-Чарышская Пристань',
           'Хабары',
           'Целинное',
           'Чарышское',
           'Шебалино',
           'Шелаболиха',
           'Шипуново',
        ],
        'Амурская область' : [  
           'Айгунь',
           'Архара',
           'Белогорск',
           'Благовещенск (Амурская область)',
           'Бурея',
           'Возжаевка',
           'Екатеринославка',
           'Ерофей Павлович',
           'Завитинск',
           'Зея',
           'Златоустовск',
           'Ивановка',
           'Коболдо',
           'Магдагачи',
           'Новобурейский',
           'Поярково',
           'Райчихинск',
           'Ромны',
           'Свободный',
           'Серышево',
           'Сковородино',
           'Стойба',
           'Тамбовка',
           'Тында',
           'Февральск',
           'Шимановск',
           'Экимчан',
           'Ядрино',
        ],
        'Архангельская область' : [  
           'Амдерма',
           'Архангельск',
           'Березник',
           'Вельск',
           'Верхняя Тойма',
           'Волошка',
           'Вычегодский',
           'Емца',
           'Илеза',
           'Ильинско-Подомское',
           'Каргополь (Архангельская область)',
           'Карпогоры',
           'Кодино',
           'Коноша',
           'Коряжма',
           'Котлас',
           'Красноборск',
           'Лешуконское',
           'Мезень',
           'Мирный (Архангельская область)',
           'Нарьян-Мар',
           'Новодвинск',
           'Няндома',
           'Онега',
           'Пинега',
           'Плесецк',
           'Савинск',
           'Северодвинск',
           'Сольвычегодск',
           'Холмогоры',
           'Шенкурск',
           'Яренск',
        ],
        'Астраханская область' : [  
           'Астрахань',
           'Ахтубинск',
           'Верхний Баскунчак',
           'Володарский',
           'Енотаевка',
           'Икряное',
           'Камызяк',
           'Капустин Яр',
           'Красный Яр (Астраханская область)',
           'Лиман',
           'Началово',
           'Харабали',
           'Черный Яр',
        ],
        'Башкортостан(Башкирия)' : [  
           'Агидель',
           'Аксаково',
           'Амзя',
           'Архангелькое',
           'Аскарово',
           'Аскино',
           'Баймак',
           'Бакалы',
           'Белебей',
           'Белорецк',
           'Бижбуляк',
           'Бирск',
           'Благовещенск (Башкирия)',
           'Большеустьикинское',
           'Бураево',
           'Верхнеяркеево',
           'Верхние Киги',
           'Верхние Татышлы',
           'Верхний Авзян',
           'Давлеканово',
           'Дуван',
           'Дюртюли',
           'Ермекеево',
           'Ермолаево',
           'Зилаир',
           'Зирган',
           'Иглино',
           'Инзер',
           'Исянгулово',
           'Ишимбай',
           'Калтасы',
           'Кананикольское',
           'Кандры',
           'Караидель',
           'Караидельский',
           'Киргиз-Мияки',
           'Красноусольский',
           'Кумертау',
           'Кушнаренково',
           'Малояз',
           'Межгорье',
           'Мелеуз',
           'Месягутово',
           'Мраково',
           'Нефтекамск',
           'Октябрьский (Башкирия)',
           'Приютово',
           'Раевский',
           'Салават',
           'Сибай',
           'Старобалтачево',
           'Старосубхангулово',
           'Стерлибашево',
           'Стерлитамак',
           'Туймазы',
           'Уфа',
           'Учалы',
           'Федоровка (Башкирия)',
           'Чекмагуш',
           'Чишмы',
           'Шаран',
           'Янаул',
        ],
        'Белгородская область' : [  
           'Алексеевка (Белгородская область)',
           'Белгород',
           'Борисовка',
           'Валуйки',
           'Вейделевка',
           'Волоконовка',
           'Грайворон',
           'Губкин',
           'Ивня',
           'Короча',
           'Красногвардейское (Белгород.)',
           'Новый Оскол',
           'Ракитное',
           'Ровеньки',
           'Старый Оскол',
           'Строитель',
           'Чернянка',
           'Шебекино',
        ],
        'Брянская область' : [  
           'Алтухово',
           'Белая Березка',
           'Белые Берега',
           'Большое Полпино',
           'Брянск',
           'Бытошь',
           'Выгоничи',
           'Вышков',
           'Гордеевка',
           'Дубровка (Брянская область)',
           'Дятьково',
           'Дятьково',
           'Жирятино',
           'Жуковка',
           'Злынка',
           'Ивот',
           'Карачев',
           'Клетня',
           'Климово',
           'Клинцы',
           'Кокаревка',
           'Комаричи',
           'Красная Гора',
           'Локоть (Брянская область)',
           'Мглин',
           'Навля',
           'Новозыбков',
           'Погар',
           'Почеп',
           'Ржаница',
           'Рогнедино',
           'Севск',
           'Стародуб',
           'Суземка',
           'Сураж',
           'Трубчевск',
           'Унеча',
        ],
        'Бурятия' : [  
           'Бабушкин',
           'Багдарин',
           'Баргузин',
           'Баянгол',
           'Бичура',
           'Выдрино',
           'Гусиное Озеро',
           'Гусиноозерск',
           'Заиграево',
           'Закаменск',
           'Иволгинск',
           'Илька',
           'Кабанск',
           'Каменск',
           'Кижинга',
           'Курумкан',
           'Кырен',
           'Кяхта',
           'Монды',
           'Мухоршибирь',
           'Нижнеангарск',
           'Орлик',
           'Петропавловка (Бурятия)',
           'Романовка (Бурятия)',
           'Северобайкальск (Бурятия)',
           'Селенгинск',
           'Сосново-Озерское',
           'Таксимо (Бурятия)',
           'Турунтаево',
           'Улан-Удэ',
           'Хоринск',
        ],
        'Владимирская область' : [  
           'Александров',
           'Андреево',
           'Анопино',
           'Бавлены',
           'Балакирево',
           'Боголюбово',
           'Великодворский',
           'Вербовский',
           'Владимир',
           'Вязники',
           'Городищи (Владимирская область)',
           'Гороховец',
           'Гусевский',
           'Гусь Хрустальный',
           'Гусь-Хрустальный',
           'Золотково',
           'Иванищи',
           'Камешково',
           'Карабаново',
           'Киржач',
           'Ковров',
           'Кольчугино',
           'Красная Горбатка',
           'Лакинск',
           'Меленки',
           'Муром',
           'Петушки',
           'Покров',
           'Радужный (Владимирская область)',
           'Собинка',
           'Судогда',
           'Суздаль',
           'Юрьев-Польский',
        ],
        'Волгоградская область' : [  
           'Алексеевская',
           'Алущевск',
           'Быково (Волгоградская область)',
           'Волгоград',
           'Волжский (Волгоградская область)',
           'Городище (Волгоградская область)',
           'Дубовка (Волгоградская область)',
           'Елань',
           'Жирновск',
           'Иловля',
           'Калач-на-Дону',
           'Камышин',
           'Кириллов',
           'Клетский',
           'Котельниково',
           'Котово',
           'Кумылженская',
           'Ленинск',
           'Михайловка',
           'Нехаевский',
           'Николаевск',
           'Новоаннинский',
           'Новониколаевский',
           'Ольховка',
           'Палласовка (Волгоградская область)',
           'Рудня (Волгоградская область)',
           'Светлый Яр',
           'Серафимович',
           'Средняя Ахтуба',
           'Сталинград',
           'Старая Полтавка',
           'Суровикино',
           'Урюпинск',
           'Фролово',
           'Чернышковский',
        ],
        'Вологодская область' : [  
           'Бабаево',
           'Белозерск',
           'Великий Устюг',
           'Верховажье',
           'Вожега',
           'Вологда',
           'Вохтога',
           'Вытегра',
           'Грязовец',
           'Кадников',
           'Кадуй',
           'Кириллов',
           'Кичменгский Городок',
           'Липин Бор',
           'Никольск',
           'Нюксеница',
           'Сокол',
           'Сямжа',
           'Тарногский Городок',
           'Тотьма',
           'Устюжна',
           'Харовск',
           'Чагода',
           'Череповец',
           'Шексна',
           'Шуйское',
        ],
        'Воронежская область' : [  
           'Анна',
           'Бобров',
           'Богучар',
           'Борисоглебск',
           'Бутурлиновка',
           'Верхний Мамон',
           'Верхняя Хава',
           'Воробьевка',
           'Воронеж',
           'Грибановский',
           'Давыдовка',
           'Елань-Коленовский',
           'Калач',
           'Кантемировка',
           'Лиски (Воронежская область)',
           'Нижнедевицк',
           'Новая Усмань',
           'Нововоронеж',
           'Новохоперск',
           'Ольховатка',
           'Острогожск',
           'Павловск (Воронежская область)',
           'Панино',
           'Петропавловка',
           'Поворино',
           'Подгоренский',
           'Рамонь',
           'Репьевка',
           'Россошь',
           'Семилуки',
           'Таловая',
           'Терновка',
           'Хохольский',
           'Эртиль',
        ],
        'Дагестан' : [  
           'Агвали',
           'Акуша',
           'Ахты',
           'Ачису',
           'Бабаюрт',
           'Бежта',
           'Ботлих',
           'Буйнакск',
           'Вачи',
           'Гергебиль',
           'Гуниб',
           'Дагестанские Огни',
           'Дербент',
           'Дылым',
           'Ершовка',
           'Избербаш',
           'Карабудахкент',
           'Карата',
           'Каспийск',
           'Касумкент',
           'Кизилюрт',
           'Кизляр',
           'Кочубей',
           'Кумух',
           'Курах',
           'Магарамкент',
           'Маджалис',
           'Махачкала',
           'Мехельта',
           'Новолакское',
           'Рутул',
           'Советское (Дагестан)',
           'Тарумовка',
           'Терекли-Мектеб',
           'Тлярата',
           'Тпиг',
           'Унцукуль',
           'Уркарах',
           'Хасавюрт',
           'Хив',
           'Хунзах',
           'Цуриб',
           'Южно-Сухокумск',
        ],
        'Еврейская область' : [  
           'Биробиджан',
        ],
        'Ивановская область' : [  
           'Архиповка',
           'Верхний Ландех',
           'Вичуга',
           'Гаврилов Посад',
           'Долматовский',
           'Дуляпино',
           'Заволжск',
           'Заречный (Ивановская область)',
           'Иваново',
           'Иваньковский',
           'Ильинское-Хованское',
           'Каминский',
           'Кинешма',
           'Комсомольск',
           'Кохма',
           'Лух',
           'Палех',
           'Пестяки',
           'Приволжск',
           'Пучеж',
           'Родники (Ивановская область)',
           'Савино',
           'Сокольское',
           'Тейково',
           'Фурманов',
           'Шуя',
           'Южа',
           'Юрьевец',
        ],
        'Иркутская область' : [  
           'Алексеевск',
           'Алзамай',
           'Алыгжер',
           'Ангарск',
           'Артемовский (Иркутская область)',
           'Байкал',
           'Байкальск',
           'Балаганск',
           'Баяндай',
           'Бирюсинск',
           'Бодайбо',
           'Большая Речка',
           'Большой Луг',
           'Бохан',
           'Братск',
           'Видим',
           'Витимский',
           'Вихоревка',
           'Еланцы',
           'Ербогачен',
           'Железногорск-Илимский',
           'Жигалово',
           'Забитуй',
           'Залари',
           'Звездный',
           'Зима',
           'Иркутск',
           'Казачинское (Иркутская область)',
           'Качуг',
           'Квиток',
           'Киренск',
           'Куйтун',
           'Култук',
           'Кутулик',
           'Мама',
           'Нижнеудинск',
           'Оса',
           'Саянск',
           'Слюдянка',
           'Тайшет',
           'Тулун',
           'Усолье-Сибирское (Иркутская область)',
           'Усть-Илимск',
           'Усть-Кут',
           'Усть-Ордынский',
           'Усть-Уда',
           'Черемхово',
           'Чунский',
           'Шелехов',
        ],
        'Кабардино-Балкария' : [  
           'Баксан',
           'Майский',
           'Нальчик',
           'Нарткала',
           'Прохладный',
           'Советское (Кабардино-Балкария)',
           'Терек',
           'Тырныауз',
           'Чегем-Первый',
        ],
        'Калининградская область' : [  
           'Багратионовск',
           'Балтийск',
           'Гвардейск',
           'Гурьевск (Калининградская область)',
           'Гусев',
           'Железнодорожный (Калининград.)',
           'Зеленоградск',
           'Знаменск',
           'Калининград (Кенигсберг)',
           'Краснознаменск (Калининград.)',
           'Ладушкин',
           'Мамоново',
           'Неман',
           'Нестеров',
           'Озерск(Калининградская область)',
           'Пионерск',
           'Полесск',
           'Правдинск',
           'Светлогорск',
           'Светлый (Калининградская область)',
           'Славск',
           'Советск (Калининградская область)',
           'Черняховск',
        ],
        'Калмыкия' : [  
           'Аршань',
           'Городовиковск',
           'Каспийский',
           'Комсомольский (Калмыкия)',
           'Малые Дербеты',
           'Приютное',
           'Советское (Калмыкия)',
           'Троицкое (Калмыкия)',
           'Утта',
           'Цаган-Аман',
           'Элиста',
           'Юста',
           'Яшалта',
           'Яшкуль',
        ],
        'Калужская область' : [  
           'Бабынино',
           'Балабаново',
           'Барятино',
           'Белоусово',
           'Бетлица',
           'Боровск',
           'Дудоровский',
           'Думиничи',
           'Еленский',
           'Жиздра',
           'Жуков',
           'Износки',
           'Калуга',
           'Киров (Калужская область)',
           'Козельск',
           'Кондрово',
           'Кремёнки',
           'Людиново',
           'Малоярославец',
           'Медынь',
           'Мещовск',
           'Мосальск',
           'Обнинск',
           'Перемышль',
           'Спас-Деменск',
           'Сухиничи',
           'Таруса',
           'Ульяново',
           'Ферзиково',
           'Хвастовичи',
           'Юхнов',
        ],
        'Камчатская область' : [  
           'Атласово',
           'Аянка',
           'Большерецк',
           'Вилючинск',
           'Елизово (Камчатская область)',
           'Ильпырский',
           'Каменское',
           'Кировский',
           'Ключи (Камчатская область)',
           'Крапивная',
           'Мильково',
           'Никольское',
           'Озерновский',
           'Оссора',
           'Палана',
           'Парень',
           'Пахачи',
           'Петропавловск-Камчатский',
           'Тигиль',
           'Тиличики',
           'Усть-Большерецк',
           'Усть-Камчатск',
        ],
        'Карелия' : [  
           'Амбарный',
           'Беломорск',
           'Валаам',
           'Вирандозеро',
           'Гирвас',
           'Деревянка',
           'Идель',
           'Ильинский (Карелия)',
           'Калевала',
           'Кемь',
           'Кестеньга',
           'Кондопога',
           'Костомукша',
           'Лахденпохья',
           'Лоухи',
           'Медвежьегорск',
           'Муезерский',
           'Олонец',
           'Петрозаводск',
           'Питкяранта',
           'Повенец',
           'Пряжа',
           'Пудож',
           'Сегежа',
           'Сортавала',
           'Суоярви',
           'Хийденсельга',
        ],
        'Кемеровская область' : [  
           'Анжеро-Судженск',
           'Барзас',
           'Белово',
           'Белогорск',
           'Березовский (Кемеровская область)',
           'Грамотеино',
           'Гурьевск',
           'Ижморский',
           'Итатский',
           'Калтан',
           'Кедровка',
           'Кемерово',
           'Киселевск',
           'Крапивинский',
           'Ленинск-Кузнецкий',
           'Мариинск',
           'Междуреченск',
           'Мыски',
           'Новокузнецк',
           'Осинники',
           'Полысаево',
           'Прокопьевск',
           'Промышленная',
           'Тайга',
           'Таштагол',
           'Тисуль',
           'Топки',
           'Тяжинский',
           'Юрга',
           'Яшкино',
           'Яя',
        ],
        'Кировская область' : [  
           'Арбаж',
           'Аркуль',
           'Белая Холуница',
           'Богородское (Кировская область)',
           'Боровой',
           'Верхошижемье',
           'Вятские Поляны (Кировская область)',
           'Зуевка',
           'Каринторф',
           'Кикнур',
           'Кильмезь',
           'Киров (Кировская область)',
           'Кирово-Чепецк',
           'Кирс',
           'Кобра',
           'Котельнич',
           'Кумены',
           'Ленинское',
           'Луза',
           'Малмыж',
           'Мураши',
           'Нагорск',
           'Нема',
           'Нововятск',
           'Нолинск',
           'Омутнинск',
           'Опарино',
           'Оричи',
           'Пижанка',
           'Подосиновец',
           'Санчурск',
           'Свеча',
           'Слободской',
           'Советск (Кировская область)',
           'Суна',
           'Тужа',
           'Уни',
           'Уржум',
           'Фаленки',
           'Халтурин',
           'Юрья',
           'Яранск',
        ],
        'Коми' : [  
           'Абезь',
           'Адзьвавом',
           'Айкино',
           'Верхняя Инта',
           'Визинга',
           'Водный',
           'Воркута',
           'Вуктыл',
           'Елецкий',
           'Емва',
           'Жешарт',
           'Заполярный',
           'Ижма',
           'Инта',
           'Ираель',
           'Каджером',
           'Кажым',
           'Кожым',
           'Койгородок',
           'Корткерос',
           'Кослан',
           'Микунь',
           'Нижний Одес',
           'Объячево',
           'Печора',
           'Сосногорск',
           'Сыктывкар',
           'Троицко-Печерск',
           'Усинск',
           'Усогорск',
           'Усть-Кулом',
           'Усть-Цильма',
           'Ухта',
        ],
        'Костромская область' : [  
           'Антропово',
           'Боговарово',
           'Буй',
           'Волгореченск',
           'Галич',
           'Горчуха',
           'Зебляки',
           'Кадый',
           'Кологрив',
           'Кострома',
           'Красное-на-Волге',
           'Макарьев',
           'Мантурово',
           'Нерехта',
           'Нея',
           'Островское',
           'Павино',
           'Парфентьево',
           'Поназырево',
           'Солигалич',
           'Судиславль',
           'Сусанино',
           'Чухлома',
           'Шарья',
           'Шемятино',
        ],
        'Краснодарский край' : [  
           'Абинск',
           'Абрау-Дюрсо',
           'Адлер',
           'Анапа',
           'Апшеронск',
           'Армавир',
           'Архипо-Осиповка',
           'Афипский',
           'Ахтырский',
           'Ачуево',
           'Белая Глина',
           'Белореченск',
           'Верхнебаканский',
           'Выселки',
           'Геленджик',
           'Гиагинская',
           'Горячий Ключ',
           'Гулькевичи',
           'Джубга',
           'Динская',
           'Ейск',
           'Ильский',
           'Кабардинка',
           'Калинино',
           'Калининская',
           'Каменномостский',
           'Каневская',
           'Кореновск',
           'Красноармейская',
           'Краснодар',
           'Кропоткин',
           'Крыловская',
           'Крымск',
           'Курганинск',
           'Кущевская',
           'Лабинск',
           'Лазаревское',
           'Ленинградская',
           'Майкоп (Краснодарский край)',
           'Мостовской',
           'Новокубанск',
           'Новороссийск',
           'Отрадная',
           'Павловская',
           'Приморско-Ахтарск',
           'Северская',
           'Славянск-на-Кубани',
           'Сочи',
           'Староминская',
           'Старощербиновская',
           'Тбилисская',
           'Темрюк',
           'Тимашевск',
           'Тихорецк',
           'Туапсе',
           'Тульский',
           'Усть-Лабинск',
           'Хадыженск',
           'Хоста',
           'Шовгеновский',
        ],
        'Красноярский край' : [  
           'Абаза',
           'Абакан',
           'Агинское',
           'Артемовск',
           'Аскиз',
           'Ачинск',
           'Байкит',
           'Балахта',
           'Балыкса',
           'Белый Яр',
           'Бея',
           'Бискамжа',
           'Боготол',
           'Боград',
           'Богучаны',
           'Большая Мурта',
           'Большой Улуй',
           'Бородино (Красноярский край)',
           'Ванавара',
           'Верхнеимбатск',
           'Горячегорск',
           'Дзержинское',
           'Дивногорск',
           'Диксон',
           'Дудинка',
           'Емельяново',
           'Енисейск',
           'Ермаковское',
           'Железногорск',
           'Заозерный',
           'Зеленогорск (Красноярский край)',
           'Игарка',
           'Идринское',
           'Иланский',
           'Ирбейское',
           'Казачинское  (Красноярский край)',
           'Канск',
           'Каратузское',
           'Караул',
           'Кодинск',
           'Козулька',
           'Копьево',
           'Краснотуранск',
           'Красноярск',
           'Курагино',
           'Лесосибирск',
           'Минусинск',
           'Мотыгино',
           'Назарово',
           'Нижний Ингаш',
           'Новоселово',
           'Норильск',
           'Партизанское',
           'Пировское',
           'Северо-Енисейский',
           'Сосновоборск (Красноярский край)',
           'Тасеево',
           'Таштып',
           'Тура',
           'Туруханск',
           'Тюхтет',
           'Ужур',
           'Уяр',
           'Хатанга',
           'Черемушки',
           'Черногорск',
           'Шалинское',
           'Шарыпово  (Красноярский край)',
           'Шира',
           'Шушенское',
        ],
        'Курганская область' : [  
           'Варгаши',
           'Глядянское',
           'Далматово',
           'Каргаполье',
           'Катайск',
           'Кетово',
           'Курган',
           'Куртамыш',
           'Лебяжье',
           'Макушино',
           'Мишкино',
           'Мокроусово',
           'Петухово',
           'Половинное',
           'Сафакулево',
           'Целинное',
           'Шадринск',
           'Шатрово',
           'Шумиха',
           'Щучье',
           'Юргамыш',
        ],
        'Курская область' : [  
           'Альменево',
           'Белая',
           'Большое Солдатское',
           'Глушково',
           'Горшечное',
           'Дмитриев-Льговский',
           'Железногорск',
           'Золотухино',
           'Касторное',
           'Конышевка',
           'Коренево',
           'Курск',
           'Курчатов',
           'Кшенский',
           'Льгов',
           'Мантурово',
           'Медвенка',
           'Обоянь',
           'Поныри',
           'Пристень',
           'Прямицыно',
           'Рыльск',
           'Суджа',
           'Тим',
           'Фатеж',
           'Хомутовка',
           'Черемисиново',
           'Щигры',
        ],
        'Липецкая область' : [  
           'Грязи',
           'Данков',
           'Доброе',
           'Долгоруково',
           'Елец',
           'Задонск',
           'Измалково',
           'Казинка',
           'Лебедянь',
           'Лев Толстой',
           'Липецк',
           'Тербуны',
           'Усмань',
           'Хлевное',
           'Чаплыгин',
        ],
        'Магаданская область' : [  
           'Анадырь (Магаданская область)',
           'Атка',
           'Беринговский',
           'Билибино',
           'Большевик',
           'Ванкарем',
           'Кадыкчан',
           'Лаврентия',
           'Магадан',
           'Мыс Шмидта',
           'Ола',
           'Омсукчан',
           'Палатка',
           'Певек',
           'Провидения',
           'Сеймчан',
           'Синегорье',
           'Сусуман',
           'Усть-Омчуг',
           'Эвенск',
           'Эгвекинот',
           'Ягодное',
        ],
        'Марий Эл' : [  
           'Волжск',
           'Дубовский',
           'Звенигово',
           'Йошкар-Ола',
           'Килемары',
           'Козьмодемьянск',
           'Куженер',
           'Мари-Турек',
           'Медведево',
           'Морки',
           'Новый Торьял',
           'Оршанка',
           'Параньга',
           'Сернур',
           'Советский (Марий Эл)',
           'Юрино',
        ],
        'Мордовия' : [  
           'Ардатов',
           'Атюрьево',
           'Атяшево',
           'Большие Березники',
           'Большое Игнатово',
           'Выша',
           'Ельники',
           'Зубова Поляна',
           'Инсар',
           'Кадошкино',
           'Кемля',
           'Ковылкино',
           'Комсомольский (Мордовия)',
           'Кочкурово',
           'Краснослободск',
           'Лямбирь',
           'Ромоданово',
           'Рузаевка',
           'Саранск',
           'Старое Шайгово',
           'Темников',
           'Теньгушево',
           'Торбеево',
           'Чамзинка',
        ],
        'Мурманская область' : [  
           'Апатиты',
           'Африканда',
           'Верхнетуломский',
           'Видяево',
           'Гаджиево',
           'Заозерск',
           'Заполярный',
           'Зареченск',
           'Зашеек',
           'Зеленоборский',
           'Кандалакша',
           'Кильдинстрой',
           'Кировск',
           'Ковдор',
           'Кола',
           'Конда',
           'Ловозеро',
           'Мончегорск',
           'Мурманск',
           'Мурмаши',
           'Никель',
           'Оленегорск',
           'Полярные Зори',
           'Полярный',
           'Ревда (Мурманская область)',
           'Североморск',
           'Снежногорск',
           'Умба',
        ],
        'Нижегородская (Горьковская)' : [  
           'Ардатов',
           'Арзамас',
           'Арья',
           'Балахна',
           'Богородск',
           'Большереченск',
           'Большое Болдино',
           'Большое Козино',
           'Большое Мурашкино',
           'Большое Пикино',
           'Бор',
           'Бутурлино',
           'Вад',
           'Варнавино',
           'Васильсурск',
           'Вахтан',
           'Вача',
           'Ветлуга',
           'Виля',
           'Вознесенское',
           'Володарск',
           'Воротынец',
           'Ворсма',
           'Воскресенское',
           'Выездное',
           'Выкса',
           'Гагино',
           'Гидроторф',
           'Горбатов',
           'Горбатовка',
           'Городец',
           'Дальнее Константиново',
           'Дзержинск',
           'Дивеево',
           'Досчатое',
           'Заволжье',
           'Керженец',
           'Княгинино',
           'Ковернино',
           'Красные Баки',
           'Кстово',
           'Кулебаки',
           'Лукоянов',
           'Лысково',
           'Навашино',
           'Нижний Новгород',
           'Новосмолинский',
           'Павлово',
           'Первомайск',
           'Перевоз',
           'Пильна',
           'Починки',
           'Саров (Нижегородская область)',
           'Семенов',
           'Сергач',
           'Сеченово',
           'Сосновское',
           'Спасское',
           'Тонкино',
           'Тоншаево',
           'Уразовка',
           'Урень',
           'Чкаловск',
           'Шаранга',
           'Шатки',
           'Шахунья',
        ],
        'Новгородская область' : [  
           'Анциферово',
           'Батецкий',
           'Большая Вишера',
           'Боровичи',
           'Валдай',
           'Великий Новгород (Новгород)',
           'Волот',
           'Деманск',
           'Зарубино',
           'Крестцы',
           'Любытино',
           'Малая Вишера',
           'Марево',
           'Мошенское',
           'Окуловка',
           'Парфино',
           'Пестово',
           'Поддорье',
           'Сольцы',
           'Старая Русса',
           'Хвойная',
           'Холм',
           'Чудово',
           'Шимск',
        ],
        'Новосибирская область' : [  
           'Баган',
           'Барабинск',
           'Бердск',
           'Биаза',
           'Болотное',
           'Венгерово',
           'Довольное',
           'Завьялово',
           'Искитим',
           'Карасук',
           'Каргат',
           'Колывань',
           'Краснозерское',
           'Крутиха',
           'Куйбышев (Новосибирская область)',
           'Купино',
           'Кыштовка',
           'Маслянино',
           'Мошково',
           'Новосибирск',
           'Норильск',
           'Обь',
           'Ордынское',
           'Северное',
           'Сузун',
           'Татарск',
           'Тогучин',
           'Убинское',
           'Усть-Тарка',
           'Чаны',
           'Черепаново',
           'Чистоозерное',
           'Чулым',
        ],
        'Омская область' : [  
           'Береговой',
           'Большеречье',
           'Большие Уки',
           'Горьковское',
           'Знаменское (Омская область)',
           'Исилькуль',
           'Калачинск',
           'Колосовка',
           'Кормиловка',
           'Крутинка',
           'Любинский',
           'Марьяновка',
           'Муромцево',
           'Называевск',
           'Нижняя Омка',
           'Нововаршавка',
           'Одесское',
           'Оконешниково',
           'Омск',
           'Павлоградка',
           'Полтавка',
           'Русская Поляна',
           'Саргатское',
           'Седельниково',
           'Таврическое',
           'Тара',
           'Тевриз',
           'Тюкалинск',
           'Усть-Ишим',
           'Черлак',
           'Шербакуль',
        ],
        'Оренбургская область' : [  
           'Абдулино',
           'Адамовка',
           'Айдырлинский',
           'Акбулак',
           'Аккермановка',
           'Асекеево',
           'Беляевка',
           'Бугуруслан',
           'Бузулук',
           'Гай',
           'Грачевка',
           'Домбаровский',
           'Дубенский',
           'Илек',
           'Ириклинский',
           'Кувандык',
           'Курманаевка',
           'Матвеевка',
           'Медногорск',
           'Новоорск',
           'Новосергиевка',
           'Новотроицк',
           'Октябрьское (Оренбург.)',
           'Оренбург',
           'Орск',
           'Первомайский (Оренбург.)',
           'Переволоцкий',
           'Пономаревка',
           'Саракташ',
           'Светлый (Оренбургская область)',
           'Северное',
           'Соль-Илецк',
           'Сорочинск',
           'Ташла',
           'Тоцкое',
           'Тюльган',
           'Шарлык',
           'Энергетик',
           'Ясный',
        ],
        'Орловская область' : [  
           'Болхов',
           'Верховье',
           'Глазуновка',
           'Дмитровск-Орловский',
           'Долгое',
           'Залегощь',
           'Змиевка',
           'Знаменское (Орловская область)',
           'Колпны',
           'Красная Заря',
           'Кромы',
           'Ливны',
           'Малоархангельск',
           'Мценск',
           'Нарышкино',
           'Новосиль',
           'Орел',
           'Покровское',
           'Сосково',
           'Тросна',
           'Хомутово',
           'Хотынец',
           'Шаблыкино',
        ],
        'Пензенская область' : [  
           'Башмаково',
           'Беднодемьяновск',
           'Беково',
           'Белинский',
           'Бессоновка',
           'Вадинск',
           'Верхозим',
           'Городище (Пензенская область)',
           'Евлашево',
           'Заречный (Пензенская область)',
           'Земетчино',
           'Золотаревка',
           'Исса',
           'Каменка',
           'Колышлей',
           'Кондоль',
           'Кузнецк',
           'Лопатино',
           'Малая Сердоба',
           'Мокшан',
           'Наровчат',
           'Неверкино',
           'Нижний Ломов',
           'Никольск (Пензенская область)',
           'Пачелма',
           'Пенза',
           'Русский Камешкир',
           'Сердобск',
           'Сосновоборск',
           'Сура',
           'Тамала',
           'Шемышейка',
        ],
        'Пермский край' : [  
           'Александровск',
           'Барда',
           'Березники',
           'Большая Соснова',
           'Верещагино',
           'Гайны',
           'Горнозаводск (Пермский край)',
           'Гремячинск',
           'Губаха',
           'Добрянка',
           'Елово',
           'Зюкайка',
           'Ильинский (Пермская область)',
           'Карагай',
           'Керчевский',
           'Кизел',
           'Коса',
           'Кочево',
           'Красновишерск',
           'Краснокамск',
           'Кудымкар',
           'Куеда',
           'Кунгур',
           'Лысьва',
           'Ныроб',
           'Нытва',
           'Октябрьский',
           'Орда',
           'Оса',
           'Оханск',
           'Очер',
           'Пермь',
           'Соликамск',
           'Суксун',
           'Уинское',
           'Усолье',
           'Усть-Кишерть',
           'Чайковский',
           'Частые',
           'Чердынь',
           'Чернореченский',
           'Чернушка',
           'Чусовой',
           'Юрла',
           'Юсьва',
        ],
        'Приморский край' : [  
           'Анучино',
           'Арсеньев',
           'Артем',
           'Артемовский (Приморский край)',
           'Большой Камень',
           'Валентин',
           'Владивосток',
           'Высокогорск',
           'Горные Ключи',
           'Горный',
           'Дальнегорск',
           'Дальнереченск',
           'Зарубино',
           'Кавалерово',
           'Каменка (Приморский край)',
           'Камень-Рыболов',
           'Кировский',
           'Лазо',
           'Лесозаводск',
           'Лучегорск',
           'Михайловка (Приморский край)',
           'Находка (Приморский край)',
           'Новопокровка',
           'Ольга',
           'Партизанск',
           'Пластун',
           'Пограничный',
           'Покровка',
           'Посьет',
           'Русский',
           'Славянка',
           'Спасск-Дальний',
           'Терней',
           'Уссурийск',
           'Фокино',
           'Хасан',
           'Хороль',
           'Черниговка',
           'Чугуевка',
           'Яковлевка',
           'Ярославский',
        ],
        'Псковская область' : [  
           'Бежаницы',
           'Великие Луки',
           'Гдов',
           'Дедовичи',
           'Дно',
           'Заплюсье',
           'Идрица',
           'Красногородское',
           'Кунья',
           'Локня',
           'Невель',
           'Новоржев',
           'Новосокольники',
           'Опочка',
           'Остров',
           'Палкино',
           'Печоры',
           'Плюсса',
           'Порхов',
           'Псков',
           'Пустошка',
           'Пушкинские Горы',
           'Пыталово',
           'Себеж',
           'Струги-Красные',
           'Усвяты',
        ],
        'Ростовская область' : [  
           'Азов',
           'Аксай (Ростовская область)',
           'Алмазный',
           'Аютинск',
           'Багаевский',
           'Батайск',
           'Белая Калитва',
           'Боковская',
           'Большая Мартыновка',
           'Вешенская',
           'Волгодонск',
           'Восход',
           'Гигант',
           'Горняцкий',
           'Гуково',
           'Донецк',
           'Донской (Ростовская область)',
           'Дубовское',
           'Егорлыкская',
           'Жирнов',
           'Заветное',
           'Заводской',
           'Зверево',
           'Зерноград',
           'Зимовники',
           'Кагальницкая',
           'Казанская',
           'Каменоломни',
           'Каменск-Шахтинский',
           'Кашары',
           'Коксовый',
           'Константиновск',
           'Красный Сулин',
           'Куйбышево',
           'Матвеев Курган',
           'Мигулинская',
           'Миллерово',
           'Милютинская',
           'Морозовск',
           'Новочеркасск',
           'Новошахтинск',
           'Обливская',
           'Орловский',
           'Песчанокопское',
           'Покровское',
           'Пролетарск',
           'Ремонтное',
           'Родионово-Несветайская',
           'Ростов-на-Дону',
           'Сальск',
           'Семикаракорск',
           'Таганрог',
           'Тарасовский',
           'Тацинский',
           'Усть-Донецкий',
           'Целина',
           'Цимлянск',
           'Чалтырь',
           'Чертково',
           'Шахты',
           'Шолоховский',
        ],
        'Рязанская область' : [  
           'Александро-Невский',
           'Горняк',
           'Гусь Железный',
           'Елатьма',
           'Ермишь',
           'Заречный (Рязанская область)',
           'Захарово',
           'Кадом',
           'Касимов',
           'Кораблино',
           'Милославское',
           'Михайлов',
           'Новомичуринск',
           'Пителино',
           'Пронск',
           'Путятино',
           'Рыбное',
           'Ряжск',
           'Рязань',
           'Сапожок',
           'Сараи',
           'Сасово',
           'Скопин',
           'Спас-Клепики',
           'Спасск-Рязанский',
           'Старожилово',
           'Ухолово',
           'Чучково',
           'Шацк',
           'Шилово',
        ],
        'Самарская область' : [  
           'Алексеевка (Самарская область)',
           'Безенчук',
           'Богатое',
           'Богатырь',
           'Большая Глушица',
           'Большая Глущица (Самарск.)',
           'Большая Черниговка',
           'Борское',
           'Волжский (Самарская область)',
           'Жигулевск',
           'Зольное',
           'Исаклы',
           'Камышла',
           'Кинель',
           'Кинель-Черкасы',
           'Клявлино',
           'Кошки',
           'Красноармейское (Самарск.)',
           'Красный Яр (Самарская область)',
           'Куйбышев',
           'Нефтегорск',
           'Новокуйбышевск',
           'Октябрьск',
           'Отрадный',
           'Пестравка',
           'Похвистнево',
           'Приволжье',
           'Самара',
           'Сергиевск',
           'Сургут (Самарская область)',
           'Сызрань',
           'Тольятти',
           'Хворостянка',
           'Чапаевск',
           'Челно-Вершины',
           'Шентала',
           'Шигоны',
        ],
        'Саратовская область' : [  
           'Александров Гай',
           'Аркадак',
           'Аткарск',
           'Базарный Карабулак',
           'Балаково',
           'Балашов',
           'Балтай',
           'Возрождение',
           'Вольск',
           'Воскресенское (Саратовск.)',
           'Горный',
           'Дергачи',
           'Духовницкое',
           'Екатериновка',
           'Ершов',
           'Ивантеевка (Саратовская область)',
           'Калининск',
           'Каменский',
           'Красноармейск (Саратовск.)',
           'Красный Кут',
           'Лысые Горы',
           'Маркс',
           'Мокроус',
           'Новоузенск',
           'Новые Бурасы',
           'Озинки',
           'Перелюб',
           'Петровск',
           'Питерка',
           'Пугачев',
           'Ровное',
           'Романовка',
           'Ртищево',
           'Самойловка',
           'Саратов',
           'Степное (Саратовская область)',
           'Татищево',
           'Турки',
           'Хвалынск',
           'Энгельс',
        ],
        'Саха (Якутия)' : [  
           'Абый',
           'Айхал',
           'Алдан',
           'Амга',
           'Батагай',
           'Бердигестях',
           'Беркакит',
           'Бестях',
           'Борогонцы',
           'Верхневилюйск',
           'Верхоянск',
           'Вилюйск',
           'Витим',
           'Власово',
           'Депутатский',
           'Жиганск',
           'Зырянка',
           'Кангалассы',
           'Ленск',
           'Майя',
           'Мирный (Саха)',
           'Нерюнгри',
           'Нижний Куранах',
           'Нюрба',
           'Олекминск',
           'Покровск',
           'Сангар',
           'Саскылах',
           'Солнечный',
           'Среднеколымск',
           'Сунтар',
           'Тикси',
           'Удачный',
           'Усть-Мая',
           'Усть-Нера',
           'Хандыга',
           'Хонуу',
           'Чернышевский',
           'Черский',
           'Чокурдах',
           'Чульман',
           'Чурапча',
           'Якутск',
        ],
        'Сахалин' : [  
           'Александровск-Сахалинский',
           'Анбэцу',
           'Анива',
           'Бошняково',
           'Быков',
           'Вахрушев',
           'Взморье',
           'Гастелло',
           'Горнозаводск (Сахалин)',
           'Долинск',
           'Ильинский (Сахалин)',
           'Катангли',
           'Корсаков',
           'Курильск',
           'Макаров',
           'Невельск',
           'Ноглики',
           'Оха',
           'Поронайск',
           'Северо-Курильск',
           'Смирных',
           'Томари',
           'Тымовское',
           'Углегорск',
           'Холмск',
           'Шахтерск',
           'Южно-Курильск',
           'Южно-Сахалинск',
        ],
        'Свердловская область' : [  
           'Алапаевск',
           'Алтынай',
           'Арамиль',
           'Артемовский (Свердловская область)',
           'Арти',
           'Асбест',
           'Ачит',
           'Байкалово',
           'Басьяновский',
           'Белоярский (Свердловская область)',
           'Березовский (Свердловская область)',
           'Бисерть',
           'Богданович',
           'Буланаш',
           'Верхний Тагил',
           'Верхняя Пышма',
           'Верхняя Салда',
           'Верхняя Синячиха',
           'Верхняя Сысерть',
           'Верхняя Тура',
           'Верхотурье',
           'Висим',
           'Волчанск',
           'Гари',
           'Дегтярск',
           'Екатеринбург',
           'Ертарский',
           'Заводоуспенское',
           'Заречный',
           'Ивдель',
           'Изумруд',
           'Ирбит',
           'Ис',
           'Каменск-Уральский',
           'Камышлов',
           'Карпинск',
           'Качканар',
           'Кировград',
           'Краснотурьинск',
           'Красноуральск',
           'Красноуфимск',
           'Кушва',
           'Лесной',
           'Михайловск',
           'Невьянск',
           'Нижние Серги',
           'Нижний Тагил',
           'Нижняя Салда',
           'Нижняя Тура',
           'Новая Ляля',
           'Новоуральск',
           'Новоуральск (Свердловская область)',
           'Оус',
           'Первоуральск',
           'Полевской',
           'Пышма',
           'Ревда (Свердловская область)',
           'Реж',
           'Рефтинск',
           'Свердловск',
           'Североуральск',
           'Серов',
           'Сосьва',
           'Среднеуральск',
           'Сухой Лог',
           'Сысерть',
           'Таборы',
           'Тавда',
           'Талица',
           'Тугулым',
           'Туринск',
           'Туринская Слобода',
        ],
        'Северная Осетия' : [  
           'Алагир',
           'Ардон',
           'Беслан',
           'Бурон',
           'Владикавказ',
           'Дигора',
           'Моздок',
           'Орджоникидзе',
           'Чикола',
        ],
        'Смоленская область' : [  
           'Велиж',
           'Верхнеднепровский',
           'Ворга',
           'Вязьма',
           'Гагарин',
           'Глинка',
           'Голынки',
           'Демидов',
           'Десногорск',
           'Дорогобуж',
           'Духовщина',
           'Ельня',
           'Ершичи',
           'Издешково',
           'Кардымово',
           'Красный',
           'Монастырщина',
           'Новодугино',
           'Починок',
           'Рославль',
           'Рудня',
           'Сафоново',
           'Смоленск',
           'Сычевка',
           'Угра',
           'Хиславичи',
           'Холм-Жирковский',
           'Шумячи',
           'Ярцево',
        ],
        'Ставропольский край' : [  
           'Александровское (Ставрополь.)',
           'Арзгир',
           'Благодарный',
           'Буденновск',
           'Георгиевск',
           'Дивное (Ставропольский край)',
           'Домбай',
           'Донское',
           'Ессентуки',
           'Железноводск(Ставропольский)',
           'Зеленокумск',
           'Изобильный',
           'Иноземцево',
           'Ипатово',
           'Карачаевск',
           'Кисловодск',
           'Кочубеевское',
           'Красногвардейское (Ставрополь.)',
           'Курсавка',
           'Левокумское',
           'Лермонтов',
           'Минеральные Воды',
           'Михайловск',
           'Невинномысск',
           'Нефтекумск',
           'Новоалександровск',
           'Новоалександровская',
           'Новопавловск',
           'Новоселицкое',
           'Преградная',
           'Пятигорск',
           'Светлоград',
           'Солнечнодольск',
           'Ставрополь',
           'Степное (Ставропольский край)',
           'Теберда',
           'Усть-Джегута',
           'Хабез',
           'Черкесск',
        ],
        'Тамбовская область' : [  
           'Бондари',
           'Гавриловка Вторая',
           'Жердевка',
           'Знаменка',
           'Инжавино',
           'Кирсанов',
           'Котовск',
           'Мичуринск',
           'Мордово',
           'Моршанск',
           'Мучкапский',
           'Первомайский (Тамбовская область)',
           'Петровское',
           'Пичаево',
           'Рассказово',
           'Ржакса',
           'Сосновка',
           'Староюрьево',
           'Тамбов',
           'Токаревка',
           'Уварово',
           'Умет',
        ],
        'Татарстан' : [  
           'Агрыз',
           'Азнакаево',
           'Аксубаево',
           'Актаныш',
           'Актюбинский',
           'Алексеевское',
           'Альметьевск',
           'Апастово',
           'Арск',
           'Бавлы',
           'Базарные Матаки',
           'Балтаси',
           'Богатые Сабы',
           'Брежнев',
           'Бугульма',
           'Буинск',
           'Васильево',
           'Верхний Услон',
           'Высокая Гора',
           'Дербешкинский',
           'Елабуга',
           'Заинск',
           'Зеленодольск',
           'Казань',
           'Камское Устье',
           'Карабаш (Татарстан)',
           'Куйбышев (Татарстан)',
           'Кукмод',
           'Кукмор',
           'Лаишево',
           'Лениногорск',
           'Мамадыш',
           'Менделеевск',
           'Мензелинск',
           'Муслюмово',
           'Набережные Челны',
           'Нижнекамск',
           'Новошешминск',
           'Нурлат',
           'Пестрецы',
           'Рыбная Слобода',
           'Сарманово',
           'Старое Дрожжаное',
           'Тетюши',
           'Черемшан',
           'Чистополь',
        ],
        'Тверская область' : [  
           'Андреаполь',
           'Бежецк',
           'Белый',
           'Белый Городок',
           'Березайка',
           'Бологое',
           'Васильевский Мох',
           'Весьегонск',
           'Выползово',
           'Вышний Волочек',
           'Жарковский',
           'Западная Двина',
           'Зубцов',
           'Изоплит',
           'Калашниково',
           'Калинин',
           'Калязин',
           'Кашин',
           'Кесова Гора',
           'Кимры',
           'Конаково',
           'Красный Холм',
           'Кувшиново',
           'Лесное',
           'Лихославль',
           'Максатиха',
           'Молоково',
           'Нелидово',
           'Оленино',
           'Осташков',
           'Пено',
           'Рамешки',
           'Ржев',
           'Сандово',
           'Селижарово',
           'Сонково',
           'Спирово',
           'Старица',
           'Тверь',
           'Торжок',
           'Торопец',
           'Удомля',
           'Фирово',
        ],
        'Томская область' : [  
           'Александровское (Томская область)',
           'Асино',
           'Бакчар',
           'Батурино',
           'Белый Яр',
           'Зырянское',
           'Итатка',
           'Каргасок',
           'Катайга',
           'Кожевниково',
           'Колпашево',
           'Кривошеино',
           'Мельниково',
           'Молчаново',
           'Парабель',
           'Первомайское',
           'Подгорное',
           'Северск',
           'Стрежевой',
           'Томск',
           'Тымск',
        ],
        'Тува (Тувинская Респ.)' : [  
           'Ак-Довурак',
           'Бай Хаак',
           'Кызыл',
           'Самагалтай',
           'Сарыг-Сеп',
           'Суть-Холь',
           'Тоора-Хем',
           'Туран',
           'Тээли',
           'Хову-Аксы',
           'Чадан',
           'Шагонар',
           'Эрзин',
        ],
        'Тульская область' : [  
           'Агеево',
           'Алексин',
           'Арсеньево',
           'Барсуки',
           'Белев',
           'Богородицк',
           'Болохово',
           'Велегож',
           'Венев',
           'Волово',
           'Горелки',
           'Донской',
           'Дубна (Тульская область)',
           'Епифань',
           'Ефремов',
           'Заокский',
           'Казановка',
           'Кимовск',
           'Киреевск',
           'Куркино',
           'Ленинский',
           'Лянтор',
           'Новомосковск',
           'Одоев',
           'Плавск',
           'Советск (Тульская область)',
           'Суворов',
           'Тула',
           'Узловая',
           'Щекино',
           'Ясногорск',
        ],
        'Тюменская область и Ханты-Мансийский АО' : [  
           'Абатский',
           'Аган',
           'Аксарка',
           'Армизонское',
           'Аромашево',
           'Белоярский (Тюменская область)',
           'Бердюжье',
           'Березово',
           'Большое Сорокино',
           'Вагай',
           'Викулово',
           'Винзили',
           'Голышманово',
           'Губкинский (Тюменская область)',
           'Заводопетровский',
           'Заводоуковск',
           'Игрим',
           'Излучинск',
           'Исетское',
           'Ишим',
           'Казанское',
           'Казым-Мыс',
           'Когалым (Тюменская область)',
           'Кондинское',
           'Красноселькуп',
           'Лабытнанги',
           'Лангепас',
           'Ларьяк',
           'Лянторский',
           'Мегион',
           'Междуреченский',
           'Мужи',
           'Муравленко (Тюменская область)',
           'Надым (Тюменская область)',
           'Находка (Тюменская область)',
           'Нефтеюганск',
           'Нижневартовск',
           'Нижняя Тавда',
           'Новоаганск',
           'Новый Уренгой (Тюменская область)',
           'Ноябрьск (Тюменская область)',
           'Нягань',
           'Октябрьское (Тюменская область)',
           'Омутинский',
           'Покачи (Тюменская область)',
           'Приобье',
           'Пыть-Ях',
           'Радужный (Ханты-Мансийский АО)',
           'Салехард',
           'Сладково',
           'Советский (Тюменская область)',
           'Сургут',
           'Тазовский',
           'Тобольск',
           'Тюмень',
           'Уват',
           'Унъюган',
           'Упорово',
           'Урай',
           'Ханты-Мансийск',
           'Югорск',
           'Юрибей',
           'Ялуторовск',
           'Яр-Сале',
           'Ярково',
        ],
        'Удмуртия' : [  
           'Алнаши',
           'Балезино',
           'Вавож',
           'Воткинск',
           'Глазов',
           'Грахово',
           'Дебесы',
           'Завьялово',
           'Игра',
           'Ижевск',
           'Кама',
           'Камбарка',
           'Каракулино',
           'Кез',
           'Кизнер',
           'Киясово',
           'Красногорское (Удмуртия)',
           'Можга',
           'Сарапул',
           'Селты',
           'Сюмси',
           'Ува',
           'Устинов',
           'Шаркан',
           'Юкаменское',
           'Якшур-Бодья',
           'Яр',
        ],
        'Ульяновская область' : [  
           'Базарный Сызган',
           'Барыш',
           'Большое Нагаткино',
           'Вешкайма',
           'Глотовка',
           'Димитровград',
           'Игнатовка',
           'Измайлово',
           'Инза',
           'Ишеевка',
           'Канадей',
           'Карсун',
           'Кузоватово',
           'Майна',
           'Новая Малыкла',
           'Новоспасское',
           'Новоульяновск',
           'Павловка',
           'Радищево',
           'Сенгилей',
           'Старая Кулатка',
           'Старая Майна',
           'Сурское',
           'Тереньга',
           'Ульяновск',
           'Чердаклы',
        ],
        'Уральская область' : [  
           'Аксай (Уральская область)',
           'Дарьинское',
           'Деркул',
           'Джамбейты',
           'Переметное',
           'Уральск',
           'Федоровка (Уральская область)',
           'Фурманово',
           'Чапаев',
        ],
        'Хабаровский край' : [  
           'Амурск',
           'Аян',
           'Березовый',
           'Бикин',
           'Бира',
           'Биракан',
           'Богородское (Хабаровский край)',
           'Ванино',
           'Волочаевка Вторая',
           'Высокогорный',
           'Вяземский',
           'Горный',
           'Гурское',
           'Дормидонтовка',
           'Заветы Ильича',
           'Известковый',
           'Иннокентьевка',
           'Комсомольск-на-Амуре',
           'Ленинское',
           'Нелькан',
           'Николаевск-на-Амуре',
           'Облучье',
           'Охотск',
           'Переяславка',
           'Смидович',
           'Советская Гавань',
           'Софийск',
           'Троицкое',
           'Тугур',
           'Хабаровск',
           'Чегдомын',
           'Чумикан',
        ],
        'Хакасия' : [  
           'Абакан',
           'Саяногорск',
           'Черногорск',
        ],
        'Челябинская область' : [  
           'Агаповка',
           'Аргаяш',
           'Аша',
           'Бакал',
           'Бреды',
           'Варна',
           'Верхнеуральск',
           'Верхний Уфалей',
           'Еманжелинск',
           'Златоуст',
           'Карабаш',
           'Карталы',
           'Касли',
           'Катав-Ивановск',
           'Копейск',
           'Коркино',
           'Красногорский',
           'Кунашак',
           'Куса',
           'Кыштым',
           'Магнитогорск',
           'Миасс',
           'Миньяр',
           'Озерск(Челябинская область)',
           'Октябрьское (Челябинская область)',
           'Пласт',
           'Сатка',
           'Сим',
           'Снежинск (Челябинская область)',
           'Трехгорный',
           'Троицк',
           'Увельский',
           'Уйское',
           'Усть-Катав',
           'Фершампенуаз',
           'Чебаркуль',
           'Челябинск',
           'Чесма',
           'Южно-Уральск',
           'Юрюзань',
        ],
        'Чечено-Ингушетия' : [  
           'Аргун',
           'Грозный',
           'Гудермес',
           'Знаменское',
           'Малгобек',
           'Назрань',
           'Наурская',
           'Ножай-Юрт',
           'Орджоникидзевская',
           'Советское (Чечено-Ингушетия)',
           'Урус-Мартан',
           'Шали',
        ],
        'Читинская область' : [  
           'Агинское',
           'Аксеново-Зиловское',
           'Акша',
           'Арбагар',
           'Атамановка',
           'Балей',
           'Борзя',
           'Букачача',
           'Газимурский Завод',
           'Давенда',
           'Дарасун',
           'Домна',
           'Дровяная',
           'Дульдурга',
           'Забайкальск',
           'Карымское',
           'Ключевский',
           'Кокуй',
           'Краснокаменск',
           'Красный Чикой',
           'Кыра',
           'Моготуй',
           'Могоча',
           'Нерчинск',
           'Нерчинский Завод',
           'Нижний Цасучей',
           'Оловянная',
           'Первомайский (Читинская область)',
           'Петровск-Забайкальский',
           'Приаргунск',
           'Сретенск',
           'Тупик',
           'Улеты',
           'Хилок',
           'Чара',
           'Чернышевск',
           'Чита',
           'Шелопугино',
           'Шилка',
        ],
        'Чувашия' : [  
           'Алатырь',
           'Аликово',
           'Батырева',
           'Буинск',
           'Вурнары',
           'Ибреси',
           'Канаш',
           'Киря',
           'Комсомольское',
           'Красноармейское (Чувашия)',
           'Красные Четаи',
           'Кугеси',
           'Мариинский Посад',
           'Моргауши',
           'Новочебоксарск',
           'Порецкое',
           'Урмары',
           'Цивильск',
           'Чебоксары',
           'Шемурша',
           'Шумерля',
           'Ядрин',
           'Яльчики',
           'Янтиково',
        ],
        'Чукотский АО' : [  
           'Анадырь (Чукотский АО)',
           'Билибино',
           'ПЕВЕК',
        ],
        'Ямало-Ненецкий АО' : [  
           'Губкинский (Ямало-Ненецкий АО)',
           'Заполярный (Ямало-Ненецкий АО)',
           'Муравленко',
           'Надым',
           'Новый Уренгой',
           'Ноябрьск',
           'Пангоды',
           'Пуровск',
           'Салехард',
           'Тазовский',
           'Тарко-Сале',
        ],
        'Ярославская область' : [  
           'Андропов',
           'Берендеево',
           'Большое Село',
           'Борисоглебский',
           'Брейтово',
           'Бурмакино',
           'Варегово',
           'Волга',
           'Гаврилов Ям',
           'Данилов',
           'Любим',
           'Мышкин',
           'Некрасовское',
           'Новый Некоуз',
           'Переславль-Залесский',
           'Пошехонье-Володарск',
           'Ростов',
           'Рыбинск',
           'Тутаев',
           'Углич',
           'Ярославль',
        ],
        'Карачаево-Черкесская Республика' : [  
           'Черкесск',
        ],
      };
const Search = ({ customStyle,selected, setCityChange }) => {
  const [searchTerm, setSearchTerm] = useState(selected || '');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showers,setShowers] = useState(false);

  useEffect(() => {
          setSearchTerm(selected);
   }, [selected]); 

  

  const handleInputChange = (e) => {
    const inputText = e.target.value.toLowerCase();
    setSearchTerm(inputText);
    setCityChange('');
    setShowers(true);
    const filteredCities = Object.keys(citiesData).reduce((acc, region) => {
      const cities = citiesData[region].filter(city => city.toLowerCase().includes(inputText));
      if (cities.length > 0) {
        acc.push({ region, cities: cities.slice(0, 5) });
      }
      return acc;
    }, []);

    setFilteredSuggestions(filteredCities);
  };
    const handleCityClick = (city) => {
        setSearchTerm(city);
        setCityChange(city);
        setShowers(false);
    };
    
  
    return (
        <div className={style.posReal}>
        <input type="text" placeholder="Твой город" value={searchTerm} onChange={handleInputChange} className={customStyle}/>
        {searchTerm && filteredSuggestions.length > 0 && (
        <div className={showers ? style.showcas + ' ' + style.selectcastom : style.selectcastom}>
          {filteredSuggestions.map((item, index) => (
            <div className={style.scroll} key={index}>
              
              {item.cities.map((city, idx) => (
                <div className={style.citysel} key={idx} onClick={() => handleCityClick(city)}>{city}</div>
              ))}
            </div>
          ))}
        </div>
        )}
      </div>
    );
  };
  Search.defaultProps = {
   selected: '',
 };
  export default Search;
